import React from 'react';
import {
  Card,
  CardBody,
  CardHeader,
  Label,
  FormGroup,
  Form,
  Input,
  Button,
} from 'reactstrap';
import { useDispatch } from "react-redux";
import { useSelector } from 'react-redux';
import { useForm } from "react-hook-form";
import { useHistory } from 'react-router-dom';
import { actionSubmitExtRef } from 'store/actions/usersActions';

const PatientUsersForm = () => {
  const dispatch = useDispatch();

  //States
  const userData = useSelector(state => state.usersPatientsReducer.editData);
  
  const { register, handleSubmit } = useForm();
  const history = useHistory();

  const onSubmit = (data) => {

    //Reduce the data in pairs
    const refinedData = Object.entries(data).reduce(
      (acc, [k,v]) => {
        let keysplit = k.split("_"); 
        let id = keysplit[keysplit.length-1]; //get iteration number
        let keyvalue = keysplit.splice(0, keysplit.length-1).join("_"); //get key without iteration number
        (acc[id] ??= {})[keyvalue] = v; 
        return acc
      }, []);
    dispatch(actionSubmitExtRef({...userData, set_ext_refs: refinedData}));
  };

  return (
    <div className="content user-manual-edit">

      <Card>
        <CardHeader>{`${userData?.firstName} ${userData?.lastName} External Reference edition form`}</CardHeader>
        <CardBody>
          <Form id="user-edit-form" onSubmit={handleSubmit(onSubmit)}>

            {userData.associated_details.map((p,i) => {
              return <>
                <Label>External Reference ({p.name})</Label>
                <FormGroup>
                  <Input
                    type="text"
                    name={`ext_ref_${i}`}
                    defaultValue={p.patient_ext_ref}
                    required
                    innerRef={register}
                  >
                  </Input>

                  <Input
                    type="hidden"
                    name={`practice_${i}`}
                    defaultValue={p.practice_id}
                    innerRef={register}
                  >
                  </Input>
                </FormGroup>
              </>
            })}
          </Form>

          <Button form="user-edit-form" size="sm" color="info" type="submit">
            Update
          </Button>

          <Button
            form="user-edit-form"
            size="sm"
            color="danger"
            type="reset"
            onClick={(e) => {
              e.preventDefault();
              history.goBack();
            }}
          >
            Cancel
          </Button>
        </CardBody>
      </Card>
    </div>
  );
};

export default PatientUsersForm;
